import {
  clearInputField,
  clearSelectField,
  getQueryStringParameter,
} from '../../../helpers';
import { phoneNumberFormatter } from '../../../phoneNumberFormatter'

const clearUnusedRadioDependantFields = ($form, $radioButtons, $field_selector) => {
  $radioButtons.each((_, element) => {
    if (element.value !== 'true') {

      $(`${$field_selector} input`, $form).each((_, inputElement) => {
        clearInputField(inputElement);
      });

      const changeEvent = new Event('change');

      $(`${$field_selector} select`, $form).each((_, selectElement) => {
        clearSelectField(selectElement);
        selectElement.selectedIndex = 0;
        selectElement.dispatchEvent(changeEvent);
      });
    }
  });
};

$(() => {
  const $form = $('form#natural-profile-form');
  const step = getQueryStringParameter('id');

  if (
    $form.length === 0
    || (step !== null && step !== '' && step !== 'client_id' && !window.location.pathname.endsWith('new'))
  ) {
    return;
  }

  const primaryPhoneNumberInput = $form[0].querySelector('#primary_phone_number_input');
  const primaryPhoneNumberErrorMessage = $form[0].querySelector('#primary_phone_number_error_message');

  phoneNumberFormatter(primaryPhoneNumberInput, primaryPhoneNumberErrorMessage);

  const authorizedRepresentativeNumberInput = $form[0].querySelector('#authorized_representative_phone_number_input');
  const authorizedRepresentativeNumberErrorMessage = $form[0]
    .querySelector('#authorized_representative_phone_number_error_message');

  phoneNumberFormatter(authorizedRepresentativeNumberInput, authorizedRepresentativeNumberErrorMessage);

  const $politicallyExposedPersonRadio = $('#politically_exposed_person_radio_buttons input[type=radio]', $form);
  const $politicallyExposedPersonTypeField = $('#politically_exposed_person_type_field', $form);

  const $authorizedRepresentativeRadio = $('#is_authorized_representative_radio_buttons input[type=radio]', $form);
  const $authorizedRepresentitiveFormFields = $('#authorized_representative_form_fields', $form);

  $authorizedRepresentativeRadio.on('change', (e) => {
    if (!e.target.checked) {
      return;
    }

    if (e.target.value === 'true') {
      $authorizedRepresentitiveFormFields.removeClass('d-none');
    } else {
      $authorizedRepresentitiveFormFields.addClass('d-none');
      clearUnusedRadioDependantFields($form, $authorizedRepresentativeRadio, '#authorized_representative_form_fields');
    }
  });

  $politicallyExposedPersonRadio.on('change', (e) => {
    if (!e.target.checked) {
      return;
    }

    if (e.target.value === 'true') {
      $politicallyExposedPersonTypeField.removeClass('d-none');
    } else {
      $politicallyExposedPersonTypeField.addClass('d-none');

      $('input', $politicallyExposedPersonTypeField).each((_, inputElement) => {
        clearInputField(inputElement);
      });
    }
  });
});
